module.exports = __webpack_public_path__ + "static/media/achtertuin.92c207d7.jpeg";